import { createMuiTheme } from '@material-ui/core';
import { GLOBAL_FONT_THEME } from 'theme/CommonTheme';

export const HEADER_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiTypography: {
            root: {
                color: '#005f9e !important'
            },
            body1: {
                fontSize: '15px !important'
            },
            caption: {
                fontSize: '14px !important'
            }
        },
        MuiButton: {
            contained: {
                color: 'white',
                backgroundColor: '#005F9E !important'
            },
            root: {
                borderRadius: 0
            }
        },
        MuiToolbar: {
            gutters: {
                paddingLeft: '0 !important'
            }
        }
    }
});

export const DIALOG_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiButton: {
            textPrimary: {
                color: '#0194d3'
            },
            label: {
                fontWeight: 600
            }
        },
        MuiTypography: {
            h6: {
                fontWeight: 600
            }
        }
    }
});
